import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'patient', en);

const PatientListConfig = {
  settings: {
    layout: {
      config: {},
    },
    nav: {
      title: 'Patients',
    },
  },
  auth: authRoles.user,
  key: MENU_ENUM.PATIENT,
  permission: PERMISSION.READ,
  routes: [
    {
      path: '/patient/list',
      component: React.lazy(() => import('./PatientList')),
    },
  ],
};

export default PatientListConfig;
